import { useCallback } from "react";
import { Button, Icon } from "@therms/atalaya";
import { jsx, jsxs } from "react/jsx-runtime";
import classnames from "classnames";
//#region src/modules/AppWrapper2/components/AppNav/components/AppItemMobile.tsx
function AppItemMobile({ active, description, icon, link, name, onClick }) {
	const handleClick = useCallback((e) => {
		e.preventDefault();
		if (!active) onClick();
	}, [onClick, active]);
	return /* @__PURE__ */ jsx("a", {
		href: link,
		onClick: handleClick,
		children: /* @__PURE__ */ jsx(Button, {
			disabled: active,
			subtle: true,
			fullWidth: true,
			children: /* @__PURE__ */ jsxs("div", {
				className: "space-x-base flex w-full items-center justify-between text-left",
				children: [/* @__PURE__ */ jsxs("div", { children: [/* @__PURE__ */ jsx("p", {
					className: classnames({ "text-color group-hover:text-color-strong group-active:text-color-subtle transition": !active }, "font-medium"),
					children: name
				}), /* @__PURE__ */ jsx("p", {
					className: classnames({ "text-color-subtle group-hover:text-color-strong group-active:text-color-subtle": !active }, "text-sm font-normal"),
					children: description
				})] }), /* @__PURE__ */ jsx("div", {
					className: `h-xl w-xl text-color-semantic sm:h-xxl sm:w-xxl flex shrink-0 items-center justify-center rounded-md ${active ? "bg-neutral" : "bg-main"}`,
					children: /* @__PURE__ */ jsx(Icon, { Icon: icon })
				})]
			})
		})
	});
}
//#endregion
export { AppItemMobile };

//# sourceMappingURL=AppItemMobile.js.map